import { Suspense, lazy } from 'react';

import { PageLoader } from '@/shared/ui';

const RegistrationAsync = lazy(() => import('./ui/Registration'));

export const Registration = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <RegistrationAsync />
    </Suspense>
  );
};
